import { combineReducers } from "redux";
import SmsPack from "routes/Home/Attendance/SettingAttendance/Sms/Definition/Module";
import Log from "routes/Home/Attendance/SettingAttendance/Sms/Log/Module";
import Assignment from "routes/Home/Attendance/SettingAttendance/Sms/Assignment/Module";
const reducers = combineReducers({
  SmsPack,
  Log,
  Assignment,
});

export default reducers;
